import { canAccessOtCosting } from './otCostingAccess';

const WELFARE_OPEN_DEPTS = new Set(['IT Development', 'ทรัพยากรบุคคล']);
const WELFARE_HR_SUPER_CODES = new Set(['012539']);

/** แผนก HR / IT Dev เข้าได้ทุก rank; แผนกอื่นใช้เกณฑ์เดียวกับ OT (Manager ขึ้นไป) */
export function canAccessManageWelfare(emp) {
  if (!emp) return false;
  const dept = emp?.organization?.level5;
  if (dept && WELFARE_OPEN_DEPTS.has(dept)) return true;
  return canAccessOtCosting(emp);
}

/**
 * ฝ่ายบุคคล (level5 = บุคคล) หรือรหัสพิเศษ — เงินค้ำ / Policy / Export / batch damage
 * (ตรงกับ PayrollExportTab)
 */
export function canManageWelfareHrAdmin(emp) {
  if (!emp) return false;
  if (WELFARE_HR_SUPER_CODES.has(String(emp.employeeCode || '').trim())) return true;
  return emp?.organization?.level5 === 'บุคคล';
}

/** Match getAllEmployees row from JWT (same rules as payroll / nav). */
export function matchEmployeeFromToken(employees, decodedToken) {
  if (!decodedToken || !employees?.length) return null;
  return (
    employees.find(
      (employee) =>
        (employee.username &&
          decodedToken?.initials &&
          employee.username === decodedToken.initials) ||
        (employee.employeeCode &&
          decodedToken?.UserCode &&
          employee.employeeCode === decodedToken.UserCode) ||
        (employee.email &&
          decodedToken?.Email &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decodedToken?.mail &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decodedToken?.preferred_username &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decodedToken?.userPrincipalName &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
    ) || null
  );
}
